import {setStore} from '../../../../src/utility/setStore'
export default {
    SET_PAGE_BANNERS(state,data) {
        state.pageBanners = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,pagesBanners,list',data)
    },
    SET_PAGE_BANNER_STATUS(state,data) {
        state.pageBannerStatus = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,pagesBanners,pageBannerStatus',data)
    },
    SET_CURRENT_PAGE_BANNER(state,data) {
        state.currentPageBanner = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,pagesBanners,currentPagesBanner',data)
    },
    SET_SECTION_HEADERS(state,data) {
        state.sectionsHeaders = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,sectionsHeaders,list',data)
    },
    SET_SECTION_HEADERS_STATUS(state,data) {
        state.sectionHeaderStatus = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,sectionsHeaders,sectionHeaderStatus',data)
    },
    SET_CURRENT_SECTION_HEADERS(state,data) {
        state.currentSectionsHeader = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,sectionsHeaders,currentSectionsHeader',data)
    },

    SET_FOOTER_PHOTOS(state,data) {
        state.footerPhotos = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerPhotos,list',data)
    },
    
    SET_CURRENT_FOOTER_PHOTOS(state,data) {
        state.currentFooterPhoto = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerPhotos,currentFooterPhoto',data)
    },
    SET_LOGOS(state,data) {
        state.Logo = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,logos,list',data)
    },
    
    SET_CURRENT_LOGO(state,data) {
        state.currentLogo = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,logos,currentLogo',data)
    },
    SET_FOOTER_PARAGRAPHS(state,data) {
        state.Paragraph = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerParagraphs,list',[data])
    },
    
    SET_CURRENT_FOOTER_PARAGRAPH(state,data) {
        state.currentFooterParagraph = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerParagraphs,currentFooterParagraph',data)
    },
    SET_FOOTER_BRANCHES(state,data) {
        state.footerBranches = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerBranches,list',data)
    },
    
    SET_CURRENT_FOOTER_BRANCHES(state,data) {
        state.currentFooterBranche = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerBranches,currentFooterBranche',data)
    },
    SET_FOOTER_SOCIALS(state,data) {
        state.footerSocials = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerSocials,list',data)
    },
    
    SET_CURRENT_FOOTER_SOCIAL(state,data) {
        state.currentFooterSocial = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerSocials,currentFooterSocial',data)
    },
    SET_FOOTER_CONTACTS(state,data) {
        state.footerContacts = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerContacts,list',data)
    },
    
    SET_CURRENT_FOOTER_CONTACT(state,data) {
        state.currentFooterContact = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,footer,footerContacts,currentFooterContact',data)
    },
    SET_SEOS(state,data) {
        state.SEO = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,seos,list',[data])
    },
    
    SET_CURRENT_SEO(state,data) {
        state.currentSEO = data;
        //setStore('moduleName','Key',value)
        setStore('website','settings,seos,currentSEO',data)
    },
};
